import { app } from '../../../app';
import {Controller} from "./sp-breadcrumbs.controller";

app.component('spBreadcrumbs', {
    templateUrl: require('./sp-breadcrumbs.html'),
    controller: Controller
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-header/sp-breadcrumbs/sp-breadcrumbs.component.js